// extracted by mini-css-extract-plugin
module.exports = {"hinweise":"hint-panel-module--hinweise--hURMr","hinweiseHeading":"hint-panel-module--hinweise-heading--2rKxL","hinweiseContent":"hint-panel-module--hinweise-content--36BRs"};